import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { I18nService, LgType } from '../../../services/prod/i18n.service'

import { ResultCode } from '../../../domain/authentication.model'
import { NotificationService } from '../../../services/notification.service'
import {
  INewsletterServiceResponse,
  ISourceTypes,
  NewsLetterService,
  NewsletterType
} from '../../../services/prod/news-letter.service'

@Component({
  selector: 'bmcore-newsletter-form',
  templateUrl: './bmcore-newsletter-form.component.html',
  styleUrls: ['./bmcore-newsletter-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreNewsletterFormComponent implements OnInit {
  @Input() beatmakerId: number

  lg: LgType
  newsletterForm: UntypedFormGroup

  constructor(
    private newsLetterService: NewsLetterService,
    private i18nService: I18nService,
    private notificationService: NotificationService,
    private formBuilder: UntypedFormBuilder
  ) {}

  ngOnInit() {
    this.lg = this.i18nService.getLanguageForPage()

    this.newsletterForm = this.formBuilder.group({
      name: [],
      email: []
    })
  }

  onSubmit() {
    const data: NewsletterType = {
      email: this.newsletterForm.value.email.email,
      name: this.newsletterForm.value.name.name,
      userId: this.beatmakerId,
      type: this.i18nService.isEng() ? ISourceTypes.prodPageEn : ISourceTypes.prodPageRu // todo: implement App detection
    }
    this.sendNews(data)
  }

  sendNews(data: NewsletterType) {
    if (this.newsletterForm.valid) {
      this.newsLetterService.subscribeToNewsletter(data).subscribe(
        (res: INewsletterServiceResponse) => {
          if (res.response.resultCode === ResultCode.Success) {
            this.notificationService.handleSuccess(this.lg.forms.subscribeMessage)
            this.newsletterForm.reset()
          } else {
            this.notificationService.handleError(
              res.response.message === 'You are already subscribe'
                ? this.lg.forms.alreadySubscribeMessage
                : res.response.message
            )
          }
        },
        err => this.notificationService.handleError(err.message)
      )
    } else {
      this.notificationService.handleError(this.lg.forms.error)
    }
  }
}
